import { Modal, Text } from "components/common"
import { t } from "i18next"
import { forwardRef, useImperativeHandle, useRef, useState } from "react"

const ConfirmationModal = forwardRef((props, ref) => {
  const { title, onOk, loading, confirmationText, okText, cancelText, onCancel, width = 500, ...rest } = props
  const modalRef = useRef()
  const [payload, setPayload] = useState()

  useImperativeHandle(ref, () => ({
    setVisible: value => modalRef.current?.setVisible(value),
    showFor: data => {
      setPayload(data)
      modalRef.current?.setVisible(true)
    },
  }))

  return (
    <Modal
      okText={okText ?? t("Yes")}
      cancelText={cancelText ?? t("No")}
      onOk={() => onOk?.(payload)}
      onCancel={() => {
        modalRef.current?.setVisible(false)
        onCancel?.()
      }}
      ref={modalRef}
      title={title}
      width={width}
      loading={loading}
      {...rest}
    >
      <Text>{confirmationText}</Text>
    </Modal>
  )
})

export default ConfirmationModal
